import { render, staticRenderFns } from "./OverlayCanvas.vue?vue&type=template&id=ad1c38c8&scoped=true&"
import script from "./OverlayCanvas.vue?vue&type=script&lang=js&"
export * from "./OverlayCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1c38c8",
  null
  
)

export default component.exports